/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Wed May 15 2024
 **/

import styled from "@emotion/styled";

import { Button, Row, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

interface JoinRoomFailedProps {
	variant: ChatUI.Size;
	retryFn: () => void;
}

export default function JoinRoomFailed(props: JoinRoomFailedProps) {
	return (
		<StyledJoinRoomFailed gap={16} horizonAlign="distribute" verticalAlign="center" variant={props.variant}>
			<Typography typoSize="Title2" typoColor="neutral_80_100">
				{_T("채팅서버 연결 실패")}
			</Typography>
			<Button.Icon
				shape="round"
				name="Refresh24"
				size="medium"
				filled="accent"
				fill="neutral_00_100"
				onClick={props.retryFn}
			/>
		</StyledJoinRoomFailed>
	);
}

const StyledJoinRoomFailed = styled(Row)<{ variant: ChatUI.Size }>`
	width: ${({ variant }) => {
		if (variant === "fullSize") return "calc(100% - 120px + 32px)";
		return "100%";
	}};
	padding: 8px 16px;
	border-radius: 12px;
	background: ${({ theme }) => theme.colors.neutral_00_68};
	backdrop-filter: blur(10px);
	align-self: center;
`;
